import { Layout, Section } from 'layout';
import { PriceImportRunScreen } from 'pages/price-imports/screens/price-import-run-screen';
import { PriceImportRunsScreen } from 'pages/price-imports/screens/price-import-runs-screen';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';

const PriceImportsPage = () => {
  const match = useRouteMatch();

  return (
    <Layout type={'sidebar_page_layout'}>
      <Section name={'content'}>
        <Switch>
          {/* The literal segment must precede `:runId`, or `/list` is swallowed
              as a run id and the list screen never renders. */}
          <Route path={`${match.url}/list`} component={PriceImportRunsScreen} />
          <Route path={`${match.url}/:runId`} component={PriceImportRunScreen} />
          <Redirect to={`${match.url}/list`} exact />
          <Route path='*' render={() => <Redirect to='/404' />} />
        </Switch>
      </Section>
    </Layout>
  );
};

export default PriceImportsPage;
